//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Modal from 'iview/src/components/modal'
import { generateRandomEntry } from '../utils/chat.utils'
export default {
  name: 'iview',
  data () {
    return {
      modal1: false,
      currentMessage: null
    }
  },
  methods: {
    confirm () {
      const randomMessage = generateRandomEntry(true)
      this.currentMessage = randomMessage
      this.$Modal.confirm({
        title: randomMessage.author,
        content: randomMessage.text,
        onOk: () => {
          this.$Message.info('OK')
        },
        onCancel: () => {
          this.$Message.info('KO')
        }
      })
    }
  },
  computed: {},
  components: {Modal}
}



// WEBPACK FOOTER //
// ./src/pages/iview.vue